(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "@braindate/util/lib/assert", "./conversationAssertions", "../schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("@braindate/util/lib/assert"), require("./conversationAssertions"), require("../schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.assert, global.conversationAssertions, global.schema);
    global.conversationNormalization = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _assert, _conversationAssertions, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hydrateConversation = hydrateConversation;
  _exports.normalizeConversation = normalizeConversation;

  /**
   * Normalize a conversation
   * @param   {Conversation} conversation - Conversation to normalize
   * @returns {number} data.result - Id of the conversation
   * @returns {NormalizedData<number>} data.entities - Normalized data entities
   *
   * @throws Will throw an exception if parameter is not an object
   */
  function normalizeConversation(conversation) {
    (0, _conversationAssertions.assertConversation)(conversation);
    return (0, _normalizr.normalize)(conversation, _schema.conversationSchema);
  }

  /**
   * Denormalize a conversation
   * @param   {number} id - Id of the conversation
   * @param   {Entities} entities - Normalized data entities
   * @returns {Conversation} Denormalized conversation
   *
   * @throws Will throw an exception if parameters are invalid
   */
  function hydrateConversation(id, entities) {
    (0, _assert.assertNumber)(id, "id");
    (0, _assert.assertObject)(entities, "entities");
    return (0, _normalizr.denormalize)(id, _schema.conversationSchema, entities);
  }
});